import { EMPTY_STRING } from '../../constants/common'
import { ASC_ORDER_SYMBOL, DESC_ORDER_SYMBOL } from '../../constants/sort'

export const TableContext = {
  Building: 'building',
  Emails: 'email',
  Flat: 'flat',
  Request: 'request',
  User: 'user',
}

// WARNING! Do not add to this constant new values if it's new table page. Use standalone row component instead.
export const TableCellName = {
  AdditionalEmails: 'additional_emails',
  AdditionalPhones: 'additional_phones',
  AddressAddress: 'address_address',
  AddressAddress2: 'address_address_2',
  AddressCity: 'address_city',
  AddressCountry: 'address_country',
  AddressInvoice: 'address_invoice',
  AddressPostcode: 'address_postcode',
  AddressStreet: 'address_street',
  AmountRestriction: 'amount_restriction',
  Area: 'area',
  Assignees: 'assignees',
  BankAccountOwner: 'bank_account_owner',
  BankBIC: 'bank_bic',
  BankIBAN: 'bank_iban',
  BankName: 'bank_name',
  Building: 'building',
  BuildingGroup: 'building_group',
  BuildingGroups: 'building_groups',
  BuildingObjectNumber: 'building_object_number',
  Category: 'category',
  ClosedAt: 'closed_at',
  ClosedBy: 'closed_by',
  Condition: 'condition',
  ConstructionYear: 'construction_year',
  ContractEnd: 'contract_end',
  Contractors: 'contractors',
  Contracts: 'contracts',
  ContractStart: 'contract_start',
  ContractType: 'contract_type',
  Created: 'created',
  CreatedBy: 'created_by',
  Deadline: 'deadline',
  DoorNumber: 'door_number',
  DueDate: 'due_date',
  Dwellers: 'dwellers',
  Email: 'email',
  Entrance: 'entrance',
  EntranceAddress: 'entrance_address',
  Equipment: 'equipment',
  ExternalId: 'external_id',
  FinancialBankName: 'financial_bank_name',
  FinancialBic: 'financial_bic',
  FinancialDeposit: 'financial_deposit',
  FinancialIban: 'financial_iban',
  FinancialOpenAmount: 'financial_open_amount',
  FinancialPaymentType: 'financial_payment_type',
  FirstName: 'first_name',
  Flat: 'flat',
  FlatCount: 'flat_count',
  FlatEntranceAddress: 'flat_entrance_address',
  FlatSpecifics: 'flat_specifics',
  Floor: 'floor',
  FullAddress: 'full_address',
  FullName: 'fullname',
  HeatType: 'heat_type',
  HouseKeeper: 'house_keeper',
  InhabitantCount: 'inhabitant_count',
  InsuranceContractNumber: 'insurance_contract_number',
  InsuranceSupplier: 'insurance_supplier',
  InsuranceType: 'insurance_type',
  Landlords: 'landlords',
  LastInvited: 'last_invited',
  LastName: 'last_name',
  LiveArea: 'live_area',
  LivingType: 'living_type',
  Location: 'location',
  Number: 'number',
  ObjectNumber: 'object_number',
  ORAGAccountant: 'orag_accountant',
  ORAGAssetManager: 'orag_asset_manager',
  ORAGBroker: 'orag_broker',
  ORAGCoolingType: 'orag_cooling_type',
  ORAGDepositType: 'orag_deposit_type',
  ORAGEdvNumber: 'orag_edv_number',
  ORAGFlatEquipment: 'orag_flat_equipment',
  ORAGFunding: 'orag_funding',
  ORAGFundings: 'orag_fundings',
  ORAGGuaranteedValue: 'orag_guaranteed_value',
  ORAGIdenticalAddress: 'orag_identical_address',
  ORAGKeys: 'orag_keys',
  ORAGMeterReading: 'orag_meter_reading',
  ORAGNumberOwner: 'orag_number_owner',
  ORAGReasonTermination: 'orag_reason_termination',
  ORAGReasonVacancy: 'orag_reason_vacancy',
  ORAGRemedy: 'orag_remedy',
  ORAGStopOverdueNotice: 'orag_stop_overdue_notice',
  ORAGTaxConsultant: 'orag_tax_consultant',
  ORAGTerminationDenied: 'orag_termination_denied',
  ORAGTerminationTime: 'orag_termination_time',
  ORAGTerminationTimeframe: 'orag_termination_timeframe',
  ORAGUnitNumber: 'orag_unit_number',
  ORAGWarranty: 'orag_warranty',
  Owner: 'owner',
  PartnerEmail: 'partner_email',
  PartnerFirstName: 'partner_first_name',
  PartnerFullName: 'partner_full_name',
  PartnerLastName: 'partner_last_name',
  PartnerMiddleName: 'partner_middle_name',
  PartnerPhone: 'partner_phone',
  PartnerSalutation: 'partner_salutation',
  PartnerTitle: 'partner_title',
  PersonalFullInfo: 'personal_full_name',
  PersonalGdprInfo: 'personal_gdpr_info',
  PersonalMiddleName: 'personal_middle_name',
  PersonalNameInfo: 'personal_name_info',
  PersonalPreferredCommunication: 'personal_preferred_communication',
  PersonalSalutation: 'personal_salutation',
  PersonalStatus: 'personal_status',
  PersonalTitle: 'personal_title',
  Phases: 'phases',
  Phone: 'phone',
  PostalCode: 'postal_code',
  PrivateUpdated: 'private_updated',
  PropertyOwners: 'property_owners',
  PropertyShare: 'property_share',
  Registered: 'registered',
  RentPaymentType: 'rent_payment_type',
  RequestCategories: 'request_categories',
  RequestNo: 'request_no',
  ResponsibleUsers: 'responsible_users',
  Role: 'role',
  RoomCount: 'room_count',
  RoomType: 'room_type',
  Salutation: 'salutation',
  Status: 'status',
  Street: 'street',
  ThreadEmailCount: 'thread_emails_count',
  Title: 'title',
  UnitNumber: 'unit_number',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
  VisibleToDwellers: 'visible_to_dwellers',
  Workers: 'workers',
}

export const TableCellSorting = {
  Asc: 'asc',
  Desc: 'desc',
  Reset: 'reset',
}

export const TableCellSortingParamValue = {
  [TableCellSorting.Asc]: ASC_ORDER_SYMBOL,
  [TableCellSorting.Desc]: DESC_ORDER_SYMBOL,
  [TableCellSorting.Reset]: EMPTY_STRING,
}
